import React, { useEffect, useRef } from 'react';

function TableGamesDonut({ d3, data }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!d3 || !containerRef.current || !data?.length) return;

    const container = containerRef.current;
    container.innerHTML = '';

    const width = 450;
    const height = 450;
    const margin = 10;
    const radius = Math.min(width, height) / 2 - margin;

    const svg = d3
      .select(container)
      .append('svg')
      .attr('viewBox', `0 0 ${width} ${height}`)
      .style('width', '100%')
      .style('height', 'auto')
      .append('g')
      .attr('transform', `translate(${width / 2}, ${height / 2})`);

    const color = d3
      .scaleOrdinal()
      .domain(data.map((d) => d.label))
      .range(['#96e6ab', '#76ace0', '#df87a8', '#f4d353', '#b59aea', '#ff9f7d']);

    const pie = d3.pie().value((d) => d.value).padAngle(0.02);
    const arcData = pie(data);
    const arc = d3.arc().innerRadius(80).outerRadius(radius);

    svg
      .selectAll('path')
      .data(arcData)
      .join('path')
      .attr('d', arc)
      .attr('fill', (d) => color(d.data.label))
      .attr('stroke', 'white')
      .style('stroke-width', '2px');

    // Build legend below the chart instead of on-slice labels
    const total = d3.sum(data, (entry) => entry.value) || 1;

    const smallAngleThreshold = 0.35; // ~20 degrees
    const largeSlices = arcData.filter((d) => d.endAngle - d.startAngle >= smallAngleThreshold);
    const smallSlices = arcData.filter((d) => d.endAngle - d.startAngle < smallAngleThreshold);

    // On-slice labels for large sections only
    const labelArc = d3.arc().innerRadius(radius * 0.5).outerRadius(radius * 0.8);
    svg
      .selectAll('text.tg-label')
      .data(largeSlices)
      .join('text')
      .attr('class', 'tg-label')
      .attr('transform', (d) => `translate(${labelArc.centroid(d)})`)
      .style('text-anchor', 'middle')
      .style('font-size', '16px')
      .style('fill', '#444')
      .text((d) => `${d.data.label} (${((d.data.value / total) * 100).toFixed(1)}%)`);

    // Remove any existing legend
    const existingLegend = container.querySelector('.tg-legend');
    if (existingLegend) existingLegend.remove();

    const legend = document.createElement('div');
    legend.className = 'tg-legend';
    Object.assign(legend.style, {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: '8px 16px',
      marginTop: '12px',
      alignItems: 'center',
      fontSize: '16px',
      color: '#444',
      justifyItems: 'start',
      alignContent: 'start',
    });

    smallSlices.forEach((d) => {
      const row = document.createElement('div');
      row.style.display = 'flex';
      row.style.alignItems = 'center';
      row.style.gap = '8px';

      const swatch = document.createElement('span');
      swatch.style.display = 'inline-block';
      swatch.style.width = '12px';
      swatch.style.height = '12px';
      swatch.style.borderRadius = '2px';
      swatch.style.background = color(d.data.label);

      const text = document.createElement('span');
      const pct = ((d.data.value / total) * 100).toFixed(1);
      text.textContent = `${d.data.label} (${pct}%)`;

      row.appendChild(swatch);
      row.appendChild(text);
      legend.appendChild(row);
    });

    // Append legend after SVG
    container.appendChild(legend);
  }, [d3, data]);

  return (
    <div className="chart-card svgfix">
      <h2>TABLE GAMES PLAYED</h2>
      <div ref={containerRef} />
    </div>
  );
}

export default TableGamesDonut;
